/*
 * Copyright (c) Nexign, JSC, 2020-2022.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.4.0
 */

import styled from 'styled-components';

import { IAttrStyled } from '@/main/types/globalTypes';
import { colors, fonts, globalThemeConstants } from '@theme/index';

import { EInputKind } from '../Input/Input';

export const FormBlockStyled = styled.div.attrs(({ className }: IAttrStyled) => ({
    className: `form-field ${className}`,
}))<IAttrStyled>`
    &:not(:last-child) {
        margin-bottom: 24px;
    }
`;

export const FormCheckboxDivStyled = styled.div.attrs(({ className }: IAttrStyled) => ({
    className: `form-field ${className}`,
}))<IAttrStyled>`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
`;

export const FormFieldStyled = styled(FormBlockStyled).attrs(({ kind }: { kind: EInputKind }) => ({
    className: `form-field_${kind}`,
}))<{ kind: EInputKind }>`

    .date-picker-dropdown .drop-down-filter__filter-button input,
    .select-container.select__select-drop-button[kind="filled"] {
        border-color: ${colors.borderColorLight};
    }

    .input-search__found-items {
        box-shadow: 0 2px 8px rgb(0 0 0 / 16%);
    }

    .drop-down-filter__button-area {
        display: none;
    }

    &.form-field_error {
        .date-picker-dropdown .drop-down-filter__filter-button input,
        input:disabled {
            border-color: ${colors.borderColorError};
        }
    }
`;

export const FormCheckboxBlockStyled = styled(FormBlockStyled)`
    width: fit-content;
    margin-top: 8px;
    margin-left: 8px;

    user-select: none;
`;

export const FormControlStyled = styled.div`
    display: grid;
    column-gap: 32px;
    grid-template-columns: repeat(2, min-content);
    align-items: center;
`;

export const FormButtonsBlockStyled = styled.div`
    > * {
        &:not(:last-child) {
            margin-right: 16px;
        }
    }
`;

export const FormLabelStyled = styled.div`
    ${fonts.textMainBold};
    margin-bottom: ${globalThemeConstants.gutter * 2}px;
`;

export const FormLabelHintStyled = styled.span`
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: flex-start;
    margin-left: 6px;

    &.close-icon-label {
        align-self: end;
    }
`;

export const FormHintSmallStyled = styled.span`
    ${fonts.textSmall}
    color: ${colors.textColorOpacity};
`;
